import * as React from "react";
//@ts-ignore
import moment from "moment";
import "moment/locale/de";
import HomeView from "./views/HomeView";
moment.locale("de");
export default function App() {
	return <HomeView />;
}
